import { Bill } from 'app/api/apiClient/settlement/types';
import { billStateTranslation } from 'app/api/i18n';
import Pill from 'app/components/v2/components/Pill';
import { billParams } from 'app/constants/param-names';
import { payeePaperworkStatusConfig } from 'app/constants/status';
import i18n from 'app/services/i18n';
import { capitalize } from 'app/utils/lib/string';

import { PayeePaperworkQueryParams } from './hooks';

export const defaultPayeePaperworkQueryParams: PayeePaperworkQueryParams = {
  [billParams.endDate]: '',
  [billParams.payeeId]: undefined,
  [billParams.payorId]: undefined,
  [billParams.search]: '',
  [billParams.startDate]: '',
  [billParams.state]: undefined,
  excludeTotalAmount: undefined,
  exportReport: undefined,
  includeTotals: undefined,
  page: undefined,
  pageSize: undefined,
  sortAsc: undefined,
  sortField: undefined,
};

export const renderPayeePaperworkPayorName = (payorName: null | string | undefined) =>
  payorName ?? i18n.t('payee:paperwork.payorNotFound', '(Payor not found)');

export const renderPayeePaperworkStatus = (bill: Bill) => (
  <Pill
    label={capitalize(billStateTranslation[bill.state])}
    statusColor={payeePaperworkStatusConfig[bill.state]?.pillColor ?? 'blue'}
  />
);
